import { render, staticRenderFns } from "./GraduationClass.vue?vue&type=template&id=a1642a46&"
import script from "./GraduationClass.vue?vue&type=script&lang=js&"
export * from "./GraduationClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports